import downloadjs from 'downloadjs';
import fileApi from '@/api/file';

async function blob(vm, file) {
  return new Blob([await fileApi.getFile(vm, file)], { type: file.contentType });
}

// Välilehti avataan heti klikkauksessa: latauksen jälkeen avattu ikkuna jäisi selaimen ponnahdusikkunaeston alle.
// Jos välilehteä ei saada auki, tiedosto ladataan.
export async function openFile(vm, file) {
  const tab = window.open('', '_blank');
  try {
    const data = await blob(vm, file);
    if (!tab) {
      downloadjs(data, file.filename, file.contentType);
      return;
    }
    tab.location.href = URL.createObjectURL(data);
  } catch (error) {
    if (tab) tab.close();
    throw error;
  }
}

export async function downloadFile(vm, file) {
  downloadjs(await blob(vm, file), file.filename, file.contentType);
}
